import { createWebHistory, createRouter } from "vue-router";
import { DOCUMENT_TITLE_PREFIX } from "@/libs/constants";

//Member routers

import company from "./company";
import settings from "./settings";
import credit from "./credit";

const routeMembers = [company,credit,settings];


const routes = [
  {
    path: "/",
    name: "main",
    component: () => import("@/views"),
    meta: {
      layout: "default",
      userOnly: false
    },
    redirect: {
      name:"login"
    }
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/Login"),
    meta: {
      layout: "login",
      userOnly: false,
      bodyClass: "loginBody"
    }
  },
  {
    path: "/member",
    name: "member",
    component: () => import("@/views/member"),
    meta: {
      userOnly: true
    },
    redirect: {
      name:"Company"
    },
    children: routeMembers
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0, left: 0 };
  }
});

router.beforeEach((to, from, next) => {
  const title = DOCUMENT_TITLE_PREFIX;

  document.title = title;
  next();
});

export default router;
